import React from 'react'
import Title from './Title'

const techs = [
  {
    name: 'JavaScript',
    image: 'javascript.svg',
  },
  {
    name: 'CSS',
    image: 'css.svg',
  },
  {
    name: 'React',
    image: 'react.svg',
  },
  {
    name: 'Redux',
    image: 'redux.svg',
  },
  {
    name: 'NextJs',
    image: 'next.svg',
  },
  {
    name: 'Material UI',
    image: 'material-ui.svg',
  },

  {
    name: 'NodeJs',
    image: 'nodejs.svg',
  },
  {
    name: 'Express',
    image: 'express.svg',
  },
  {
    name: 'MongoDb',
    image: 'mongodb.svg',
  },
  {
    name: 'MySql',
    image: 'mysql.svg',
  },
  {
    name: 'Postgresql',
    image: 'postgresql.svg',
  },
  {
    name: 'Redis (Caching)',
    image: 'redis.svg',
  },
  {
    name: 'Git',
    image: 'git.svg',
  },
  {
    name: 'Docker',
    image: 'docker.svg',
  },
  {
    name: 'Github Actions (CI/CD)',
    image: 'github-actions.svg',
  },
  {
    name: 'Aws (EC2, RDS, S3)',
    image: 'aws.svg',
  },
]

const Tech = () => {
  return (
    <section id='tech'>
      <Title title='Techs Used' />
      <div className='flex flex-wrap'>
        {techs.map((tech) => (
          <button key={tech.name}>
            <img src={`/stack/${tech.image}`} alt={tech.name} />
            <p>{tech.name}</p>
          </button>
        ))}
      </div>
    </section>
  )
}

export default Tech
